import { Link } from 'react-router-dom';

const socials = [
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/daily.grind.design/',
    testid: 'footer-social-instagram',
    path: 'M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4H7.6m9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8 1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5 5 5 0 0 1-5 5 5 5 0 0 1-5-5 5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3z',
  },
  {
    label: 'YouTube',
    href: 'https://www.youtube.com/@DailyGrindDesignLLC',
    testid: 'footer-social-youtube',
    path: 'M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z',
  },
  {
    label: 'TikTok',
    href: 'https://www.tiktok.com/@dailygrinddesignllc',
    testid: 'footer-social-tiktok',
    path: 'M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z',
  },
];

const SocialIcon = ({ label, href, testid, path }) => (
  <a href={href} target="_blank" rel="noopener noreferrer" aria-label={label} data-testid={testid} className="w-10 h-10 bg-red-600 rounded-full flex items-center justify-center hover:bg-red-700 transition-colors">
    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d={path} /></svg>
  </a>
);

const BrandColumn = () => (
  <div>
    <div className="text-xl font-bold bg-gradient-to-r from-red-400 to-red-600 bg-clip-text text-transparent mb-4" style={{ fontFamily: 'Bree Serif, serif' }}>
      Daily Grind Design
    </div>
    <p className="text-gray-400 mb-6">Transforming small businesses and startups into memorable brands that drive growth and success.</p>
    <div className="flex space-x-4">
      {socials.map((s) => <SocialIcon key={s.label} {...s} />)}
    </div>
  </div>
);

const FooterColumn = ({ title, children }) => (
  <div>
    <h4 className="text-lg font-semibold mb-4">{title}</h4>
    {children}
  </div>
);

const ServicesColumn = () => (
  <FooterColumn title="Services">
    <ul className="space-y-2 text-gray-400">
      <li className="hover:text-red-400 transition-colors cursor-pointer">Promotional Designs</li>
      <li className="hover:text-red-400 transition-colors cursor-pointer">Logo Design</li>
      <li className="hover:text-red-400 transition-colors cursor-pointer">Website Building</li>
    </ul>
  </FooterColumn>
);

const CompanyColumn = () => (
  <FooterColumn title="Company">
    <ul className="space-y-2 text-gray-400">
      <li><Link to="/about" className="hover:text-red-400 transition-colors">About Us</Link></li>
      <li><a href="/#process" className="hover:text-red-400 transition-colors">Our Process</a></li>
      <li><Link to="/portfolio" className="hover:text-red-400 transition-colors">Portfolio</Link></li>
    </ul>
  </FooterColumn>
);

const ContactColumn = () => (
  <FooterColumn title="Contact Info">
    <div className="space-y-2 text-gray-400">
      <div>admin@dailygrinddesign.com</div>
      <div>Response within 24 hours</div>
    </div>
  </FooterColumn>
);

const Footer = () => (
  <footer className="bg-gray-900 text-white py-12">
    <div className="container mx-auto px-6">
      <div className="grid md:grid-cols-4 gap-8">
        <BrandColumn />
        <ServicesColumn />
        <CompanyColumn />
        <ContactColumn />
      </div>
      <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400">
        <p>&copy; 2025 Daily Grind Design. All rights reserved. Built with precision for your success.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
